import 'regenerator-runtime/runtime'

import { h, render } from "preact";
import { Provider } from "@urql/preact";
import { Root } from "./components/Root/Root";

import "./stationview.scss";
import { Client } from "./lib/graphql";

const root = document.getElementById("root");
render(
  <Provider value={Client}>
    <Root />
  </Provider>,
  root
);
